/* eslint-disable @typescript-eslint/prefer-regexp-exec */

import { isServerSide, isMobile } from '@utils';

/* eslint-disable no-cond-assign */
function getBrowser() {
  if (typeof navigator === 'undefined') return;
  const ua = navigator.userAgent;
  let tem;
  let M =
    ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) ||
    [];
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
    return { name: 'IE', version: tem[1] || '' };
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\bOPR|Edge\/(\d+)/);
    if (tem != null) {
      return { name: 'Opera', version: tem[1] };
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((tem = ua.match(/version\/(\d+)/i)) != null) {
    M.splice(1, 1, tem[1]);
  }
  return {
    name: M[0],
    version: M[1],
  };
}

export const useSupportedBrowser = () => {
  if (isServerSide()) {
    return;
  }

  const browser = getBrowser();

  if (isMobile()) {
    return true;
  }

  if (browser?.name === 'Chrome' && Number(browser?.version) >= 49) return true;
  if (browser?.name === 'Firefox' && Number(browser?.version) >= 29)
    return true;
  if (browser?.name === 'Opera') return true;
  if (browser?.name === 'Safari' || browser?.name === 'IE') return false;

  return false;
};
